import { PreguntasTipoEnum } from "@shared/enums";
import { PreguntaImportador } from "../PreguntaImportador";
import { DatosPreguntaImportador } from "../DatosPreguntaImportador";
import { PREGUNTA_PADRE } from "../constantesImportador";

export class PreguntaVideoImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.VIDEO;
    }

    public testear(datos: DatosPreguntaImportador[], esUltima: boolean = false): boolean {
        let pasoTests = super.testear(datos, esUltima);
        const preguntaPadre = datos[PREGUNTA_PADRE];
        if (preguntaPadre.item == null || preguntaPadre.item === "") {
            this.errores.push("La pregunta de video no tiene la url en la columna ##Items");
            pasoTests = false;
        }
        return pasoTests;
    }
}
